const US_ZIP = /^\d{5}(-\d{4})?$/;

// USA requires a 5-digit ZIP or ZIP+4; other countries only need a non-empty
// postcode (enforced elsewhere). Mirrors Orion get-billing-address-info.ts.
export function isValidPostCode(alpha3: string | undefined, postCode: string): boolean {
  if (alpha3?.toUpperCase() !== "USA") {
    return true;
  }
  return US_ZIP.test(postCode.trim());
}
